// JsFromRoutes CacheKey c0d437e396ea1d72d271e8c6564f6cbe
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/prospects/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/admin/quoting/prospects/:id/edit'),
}
